import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const PeopleWithDisabilitiesChartsDataContext = createContext();

const PeopleWithDisabilitiesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.PEOPLE_WITH_DISABILITIES_DISABILITY,
            url: 'governanceroom/dashboard/unifiedregistry/disability/people-with-disabilities'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  peopleWithDisabilities:
                      data?.indicators?.peopleWithDisabilities ?? 0,
                  averageOfDisabledPerFamily:
                      data?.indicators?.averageOfDisabledPerFamily ?? 0,
                  percentagePeopleWithDisabilities:
                      data?.indicators?.percentagePeopleWithDisabilities ?? 0
              },
              ageGroup: data?.ageGroup ?? [],
              disabilities: data?.disabilities ?? []
          }
        : {
              indicators: {
                  peopleWithDisabilities: 0,
                  averageOfDisabledPerFamily: 0,
                  percentagePeopleWithDisabilities: 0
              },
              ageGroup: [],
              disabilities: []
          };

    return (
        <PeopleWithDisabilitiesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </PeopleWithDisabilitiesChartsDataContext.Provider>
    );
};

export default PeopleWithDisabilitiesChartsDataProvider;
